<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div v-if="!loadingBusiness">
              <ValidationObserver
                v-if="business"
                v-slot="{ handleSubmit, invalid, touched }"
                ref="updateForm"
              >
                <form
                  class="authentication-form"
                  @submit.prevent="handleSubmit(updateBusiness)"
                >
                  <div class="row">
                    <div class="col-lg-4">
                      <TextInput
                          v-model="business.business_name"
                          name="business_name"
                          rules="required"
                          label="Business Name"
                      />
                    </div>
                    <div class="col-lg-5">
                      <div class="row">
                        <div class="col-md-6">
                          <TextInput
                              v-model="business.address"
                              name="business_address"
                              rules="required"
                              label="Address"
                          />
                        </div>
                        <div class="col-md-6">
                          <TextInput
                              v-model="business.city"
                              name="business_city"
                              rules="required"
                              label="City"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="row">
                        <div class="col-md-5">
                          <TextInput
                              v-model="business.state"
                              name="business_state"
                              rules="required"
                              label="State"
                          />
                        </div>
                        <div class="col-md-7">
                          <TextInput
                              v-model="business.zip"
                              name="business_zip"
                              rules="required"
                              label="Zip"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-md-6">
                          <TextInput
                              v-model="business.country"
                              name="country"
                              label="Country"
                          />
                        </div>
                        <div class="col-md-6 mb-sm-4">
                          <label>Business Phone</label>
                          <VuePhoneNumberInput v-model="business.business_phone" valid-color="#e2e7f1" @update="businessPhoneUpdated" />
                          <!--                          <TextInput
                                                        v-model="business.business_phone"
                                                        v-mask="'(###) ###-####'"
                                                        name="business_phone"
                                                        rules="required|phone_number"
                                                        label="Business Phone"
                                                    />-->
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="row">
                          <div class="col-md-6">
                            <TextInput
                                v-model="business.origin"
                                name="origin"
                                label="Originating URL"
                            />
                          </div>
                          <div class="col-md-6">
                            <TextInput
                                v-model="business.business_website"
                                name="business_website"
                                label="Website URL"
                            ><span v-if="business.business_website"><a :href="business.business_website" target="_blank" class="btn btn-dark-blue link-target align-middle"><Feather class="link-eye" type="eye" /></a></span></TextInput>
                          </div>
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row btn-links">
                        <div v-if="business.place_id" class="col-md-6 mb-sm-3">
                          <label class="d-block">Maps Link</label>
                          <a class="btn btn-dark-blue form-control" target="_blank" :href="business.google_maps_url"><span class="d-inline-block align-top">View Business On Maps</span> <Feather class="ml-2 hidden-sm hidden-xs" type="eye" /></a>
                        </div>
                        <div class="col-sm-6">
                          <TextInput
                              v-model="business.date"
                              name="date"
                              label="Date Created"
                              disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-md-6 col-lg-3">
                      <TextInput
                        v-model="business.first_name"
                        name="first_name"
                        rules="required"
                        label="First Name"
                      />
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <TextInput
                        v-model="business.last_name"
                        name="last_name"
                        rules="required"
                        label="Last Name"
                      />
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label>Phone Number</label>
                      <VuePhoneNumberInput
                        :key="'customer-phone-' + business.id + '-' + phoneDefaultCountryCode"
                        v-model="business.phone_number"
                        :default-country-code="phoneDefaultCountryCode"
                        :no-use-browser-locale="true"
                        :error="phoneError"
                        valid-color="#e2e7f1"
                        rules="required"
                        @update="phoneUpdated"
                      />
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <TextInput
                          v-model="business.email"
                          name="owner.email"
                          rules="required|email"
                          label="Email"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div v-if="business.user_id" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.active">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">Business Status</span>
                          <b-form-checkbox
                              v-model="business.active"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_re')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_reply_engine">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">AI Review Reply</span>
                          <b-form-checkbox
                              v-model="business.is_reply_engine"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_te')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_tap_engine">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">NFC Reviews</span>
                          <b-form-checkbox
                              v-model="business.is_tap_engine"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_social_review')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_social_review">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">Social Review Posting</span>
                          <b-form-checkbox
                              v-model="business.is_social_review"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_social_fusion')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_social_fusion">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">AI Social Media Posts</span>
                          <b-form-checkbox
                              v-model="business.is_social_fusion"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_review_requester')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_text_requester">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">Email/SMS Review Requests</span>
                          <b-form-checkbox
                              v-model="business.is_text_requester"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="agencyHasModule('has_insta_stream')" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.is_insta_stream">Active</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">Instagram Feed</span>
                          <b-form-checkbox
                              v-model="business.is_insta_stream"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div v-if="isRepuAgency" class="d-inline-block mr-3 mb-3">
                        <small class="mb-1 font-weight-bold d-block text-right" style="padding-right: 25px">
                          <span v-if="business.zensocial_business">Enabled</span>
                          <span v-else>Disabled</span>
                        </small>
                        <div class="d-inline-flex">
                          <span class="mr-2 d-flex">Review Widgets</span>
                          <b-form-checkbox
                              v-model="business.zensocial_business"
                              size="sm"
                              name="initial-button"
                              switch
                              inline
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <table v-if="showBusinessLimits" class="table mt-5">
                        <thead class="btn-dark-blue">
                          <tr>
                            <td colspan="2" class="text-center">Business Limits</td>
                          </tr>
                        </thead>
                        <caption class="text-muted">
                          Set any limit to <strong>0</strong> for unlimited usage.
                        </caption>
                        <tbody>
                          <tr v-if="agencyHasModule('has_re')">
                            <td class="align-middle">Ai Review Reply: Monthly Reply Limit</td>
                            <td><input v-model.number="business.limits.reply_engine_reply_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr v-if="agencyHasModule('has_te')">
                            <td class="align-middle">NFC Reviews: Employee Limit</td>
                            <td><input v-model.number="business.limits.tap_engine_employee_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr v-if="agencyHasModule('has_social_review')">
                            <td class="align-middle">Social Review Posting: Monthly Post Limit</td>
                            <td><input v-model.number="business.limits.social_reviews_post_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr v-if="agencyHasModule('has_social_fusion')">
                            <td class="align-middle">AI Social Media Posts: Monthly Post Limit</td>
                            <td><input v-model.number="business.limits.social_fusion_post_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr v-if="agencyHasModule('has_review_requester')">
                            <td class="align-middle">Email/SMS Review Request: Monthly Text Message Limit</td>
                            <td><input v-model.number="business.limits.review_surge_text_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr v-if="agencyHasModule('has_review_requester')">
                            <td class="align-middle">Email/SMS Review Request: Monthly Email Limit</td>
                            <td><input v-model.number="business.limits.review_surge_email_limit" type="number" class="form-control"></td>
                          </tr>
                          <tr>
                            <td class="align-middle">User Limit</td>
                            <td><input v-model.number="business.limits.team_user_limit" type="number" class="form-control"></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <b-form-group>
                    <button type="button" class="btn btn-success border-0 mr-4 btn-create-widget" :disabled="loadingOptIn" @click="optInLead">
                      <b-spinner v-if="loadingOptIn" small />
                      <span v-else>
                        <span v-if="!business.user_id">
                          Create Customer & Send Google Connect Info
                        </span>
                        <span v-else>
                          Resend Google Connect Info
                        </span>
                      </span>
                    </button>
                    <span v-if="(invalid && touched)"></span>
                    <b-button
                        variant="primary"
                        class="float-right"
                        :disabled="loadingUpdate || (invalid && touched)"
                        type="submit"
                    >
                      <b-spinner v-if="loadingUpdate" small />
                      <span v-else>Save</span>
                    </b-button>
                  </b-form-group>
                </form>
              </ValidationObserver>
            </div>
            <div v-else class="text-center">
              <b-spinner></b-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { businessLimitsEnabledForUser } from '@utils/businessLimitsFeature';
import { applyPhoneFieldsToBusiness, resolveCountryFromPhone } from '@utils/phone';
export default {
  components:{
    VuePhoneNumberInput
  },
  data() {
    return {
      countries: [{ key: 'US', label: 'United States of America' }, { key: 'CA', label: 'Canada' }],
      loadingBusiness: false,
      business: null,
      loadingUpdate: false,
      loadingPassword: false,
      loadingOptIn:false,
      updatingOptIn:false,
      phoneError:false,
      phoneObject: null,
      businessPhoneObject: null,
      password: {
        password: '',
        password_confirmation: '',
      },
      open:false,
    }
  },

  computed: {
    timezones() {
      return this.$store.getters['app/timezones']
    },

    currencies() {
      return this.$store.getters['app/currencies']
    },

    dateFormats() {
      return this.$store.getters['app/dateFormats']
    },

    onlyCountries() {
      return [ this.business.country ]
    },
    user() {
      return this.$store.getters['auth/user']
    },

    showBusinessLimits() {
      const u = this.user
      if (!u) {
        return false
      }

      // RepuAgency premium only — not available on mini-app SKUs
      return businessLimitsEnabledForUser(u)
    },

    phoneDefaultCountryCode() {
      if (!this.business) {
        return 'US'
      }
      return (
        resolveCountryFromPhone(this.business.phone_number) ||
        (this.phoneObject && this.phoneObject.countryCode) ||
        'US'
      )
    },
  },
  mounted() {
    this.$nextTick();
    this.getBusiness();
  },

  methods: {
    phoneUpdated(phone) {
      this.phoneObject = phone;
    },
    businessPhoneUpdated(phone) {
      this.businessPhoneObject = phone;
    },
    applyPhoneNumbersToBusiness() {
      applyPhoneFieldsToBusiness(this.business, {
        phoneObject: this.phoneObject,
        businessPhoneObject: this.businessPhoneObject,
      });
    },
    optInLead(){
      this.applyPhoneNumbersToBusiness();
      this.loadingOptIn = true;
      this.$store
          .dispatch('business/optIn', this.business)
          .then((payload) => {
            const business = payload && payload.data ? payload.data : payload
            // Keep local state in sync with backend (important for user_id / button label)
            if (business) {
              this.business = business
            }
            if (payload && payload.message) {
              Vue.$toast && Vue.$toast.open({
                message: payload.message,
                type: 'success',
                duration: 5000,
              })
            }
            this.loadingOptIn = false
            this.updatingOptIn = false;
          })
          .catch((err) => {
            this.loadingOptIn = false
            const message =
              (err && err.response && err.response.data && (err.response.data.message || err.response.data.error)) ||
              'Failed to send the setup email. Please try again.'
            const errorId = err && err.response && err.response.data && err.response.data.error_id
            Vue.$toast && Vue.$toast.open({
              message: errorId ? `${message} (Error ID: ${errorId})` : message,
              type: 'error',
              duration: 7000,
            })
            if (err.response.data.errors) {
              this.$refs.updateForm.setErrors(err.response.data.errors)
            }
            this.updatingOptIn = false;
          })
    },
    updateBusiness() {
      if(this.updatingOptIn){
        return this.optInLead();
      }
      this.applyPhoneNumbersToBusiness();
      this.loadingUpdate = true
      this.phoneError = false;
      const payload = { ...this.business }
      if (!this.showBusinessLimits) {
        delete payload.limits
      }
      this.$store
        .dispatch('business/update', payload)
        .then((res) => {
          this.loadingUpdate = false
        })
        .catch((err) => {
          this.loadingUpdate = false
          if (err.response.data.errors) {
            this.$refs.updateForm.setErrors(err.response.data.errors)
            if(Object.keys(err.response.data.errors).includes('phone_number')){
              this.phoneError = true;
            }
          }
        })
    },

    getBusiness() {
      this.loadingBusiness = true
      this.$store
        .dispatch('business/find', this.$route.params.id)
        .then((business) => {
          this.loadingBusiness = false;
          this.$nextTick();
          business.message_limit = business.no_messages != null
          business.contact_limit = business.no_contacts != null
          if (!business.limits || typeof business.limits !== 'object') {
            business.limits = {}
          }
          const limitKeys = ['reply_engine_reply_limit', 'tap_engine_employee_limit', 'social_reviews_post_limit', 'social_fusion_post_limit', 'review_surge_text_limit', 'review_surge_email_limit', 'team_user_limit']
          limitKeys.forEach(k => { if (business.limits[k] == null) business.limits[k] = 0 })
          this.business = business
          this.phoneObject = null
          this.businessPhoneObject = null
          const rwgReviews = {
              current_page:1,
              data: business.reviews,
              next_page_url:null
          };
          sessionStorage.setItem('rwg_' + business.place_id,JSON.stringify({
            place_id:business.place_id,
            business_name:business.business_name,
            rating:5,
            total_review:1,
            reviews:rwgReviews
          }));
          setTimeout(function(){
            document.documentElement.dispatchEvent(new CustomEvent('setupRWG'));
          }, 100);
        })
        .catch(() => {
          this.$router.push({ name: 'agency.businesses.index' })
          this.loadingBusiness = false
        }).finally(() => {
      })
    },

    changePassword() {
      this.loadingPassword = true

      this.$store
        .dispatch('user/changePassword', {
          ...this.password,
          user_id: this.business.owner.id,
        })
        .then(() => {
          this.password = {}
          this.loadingPassword = false
          this.$refs.passwordForm.reset()
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$refs.passwordForm.setErrors(err.response.data.errors)
          }
          this.loadingPassword = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import url('https://unpkg.com/vue-tel-input@5.12.0/dist/vue-tel-input.css');
  i.feather--eye{
    margin-top: -3px;
  }
  .btn-links .btn{
    white-space: nowrap;
   span{
      vertical-align: top;
    }
  }
  input[name="unique_id"] {
    max-width: 150px !important;
  }
  .copy-link, .link-target{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .link-target{
    max-height: 39px;
  }
  .business-reviews{
    border-top: 2px solid #ccc;
    padding-top: 20px;
  }
</style>
<style lang="scss">
.business-reviews{
  .rwg-app-example-slider{
    .rwg-title{
      display: none;
    }
    .rwg-review-header{
      display: none;
    }
  }
}
#MazPhoneNumberInput {
  label.input-tel__label, label.country-selector__label {
    color: #4b4b5a !important;
    font-weight: normal;
  }
}
</style>
